import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * useSEO Hook
 * Centrally manages SEO meta tags (noindex, nofollow) based on route and environment.
 * Ensures that protected admin areas are never indexed by robots.
 */
export const useSEO = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Define routes that must NOT be indexed
        const hostname = window.location.hostname;
        const isProtected =
            pathname.startsWith('/gonova-orbit') ||
            pathname.startsWith('/gnm/admin/intranet') ||
            hostname.includes('staging') ||
            hostname.includes('firebaseapp.com') ||
            hostname.includes('web.app') ||
            hostname === 'localhost';

        let meta = document.querySelector('meta[name="robots"]');

        if (isProtected) {
            if (!meta) {
                meta = document.createElement('meta');
                meta.name = "robots";
                document.head.appendChild(meta);
            }
            meta.content = "noindex, nofollow";
        } else {
            // Restore default indexing for public pages
            if (meta) {
                meta.content = "index, follow";
            }
            // If the meta tag didn't exist originally, we don't necessarily 
            // need to create an "index, follow" one, but it doesn't hurt.
        }
    }, [pathname]);
};
